import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import Cookies from "js-cookie";
import { FiMail } from "react-icons/fi";
import Image from "next/image";
import GoogleLoginButton from "../components/GoogleLoginButton";
import FacebookLoginButton from "pages/components/FacebookLoginButton";
import AppleLoginButton from "pages/components/applebutton";
import useTranslate from "utils/useTranslate";
import { Modal, Button } from "react-bootstrap";
const Login = () => {
  const router = useRouter();
  const [contact, setContact] = useState("");
  const [isEmail, setIsEmail] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [mounted, setMounted] = useState(false); // ✅ to fix SSR layout shift
  const [currentQR, setCurrentQR] = useState(null);
  const [brandInfo, setBrandInfo] = useState(null);
  const [qrAlertMessage, setQrAlertMessage] = useState("");
  const [showConsentModal, setShowConsentModal] = useState(false);
const [agreePolicy, setAgreePolicy] = useState(false);
const [storeDataConsent, setStoreDataConsent] = useState(false);
const [showConsent, setShowConsent] = useState(false);
  const texts = useTranslate({
    loginHeading: "Login to QRitagya",
    loginSubtext: "6 digit code will be sent on your email or mobile no.",
    placeholderContact: "Enter your email or mobile",
    sendOtp: "Send OTP",
    sendingOtp: "Sending OTP...",
    orText: "or",
    newUser: "New User?",
    createAccount: "Create An Account",
    invalidUser: "Invalid user or you don’t have a tag.",
    genericError: "Something went wrong. Please try again later.",

      agreeText: "By continuing, I agree to the",
  privacyPolicy: "Privacy Policy",
  termsConditions: "Terms & Conditions",
  and: "and",
dataConsentShort:
  "I consent to QRitagya storing my data and receiving alerts...",

dataConsentFull:
  "I consent to QRitagya storing my personal data for account management and receiving notifications and alerts related to my QR tag and account.",

seeMore: "See more",
seeLess: "See less",
legalNotice: "IMPORTANT LEGAL NOTICE",
  companyName: "L.L.P",
  noticeHeading: "Notice under Section 5, DPDPA 2023",

  noticeReadTitle: "Please read this notice carefully.",
  noticeReadDesc:
    "By providing your consent and completing registration, you acknowledge that you have read and understood the following information.",

  personalDataTitle: "Personal data we will process:",
  personalDataDesc:
    "your phone number, and (if you provide them) your name and email.",

  purposeTitle: "Purpose of processing:",
  purposeDesc:
    "to link this QR tag to you and to notify you—with the scan location, date and time—whenever your tag is scanned, so you can recover your item.",

  consentTitle: "How to give consent:",
  consentDesc:
    "by ticking the consent box and completing registration.",

  withdrawTitle: "How to withdraw consent:",
  withdrawDesc:
    "at any time via your account settings or by emailing",

  rightsTitle: "How to exercise your rights:",
  rightsDesc:
    "to access, correct, or erase your data, or to nominate a representative, email",

  complaintTitle: "How to complain:",
  complaintDesc:
    "you may lodge a grievance with our Grievance Officer",

  contactTitle: "Contact of Data Fiduciary / DPO:",

  footerNote:
    "Please ensure you have read the above notice before proceeding.",

  understandBtn: "I Understand", 
  });

  useEffect(() => {
    setMounted(true); // ✅ ensures we only render after mount
  }, []);
  useEffect(() => {
    const brandCookie = Cookies.get("qr_brand_data");
    if (brandCookie) {
      try {
        const parsed = JSON.parse(brandCookie);
        console.log("Brand data from cookie:", parsed.brand.brand_image);
        setBrandInfo(parsed);
      } catch (err) {
        console.error("Invalid brand data cookie");
      }
    }
  }, []);
  useEffect(() => {
    const alertsCookie = Cookies.get("qr_alert_messages");
    if (alertsCookie) {
      try {
        console.log("Checking for qr_alert_messages cookie");
        const alerts = JSON.parse(alertsCookie);
        const found = alerts.find((a) => a.key === "LOGIN_PAGE");
        console.log("Found alert message:", found);
        if (found?.message) setQrAlertMessage(found.message);
      } catch (err) {
        console.error("Failed to parse qr_alerts_data cookie", err);
      }
    }
  }, []);
  const handleContactChange = (e) => {
    const value = e.target.value;
    setContact(value);
    setIsEmail(value.includes("@"));
  };

useEffect(() => {
  if (!mounted) return;

  if (router.pathname !== "/authentication/login") return;

  const isInstalled =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  if (isInstalled) return;

  if (window.deferredPrompt) {
    const timer = setTimeout(async () => {
      const allow = window.confirm(
        "📲 Add QRitagya to your Home Screen for faster access!"
      );

      if (allow) {
        window.deferredPrompt.prompt();

        const choice = await window.deferredPrompt.userChoice;

        if (choice.outcome === "accepted") {
          console.log("User installed app");
        }

        window.deferredPrompt = null;
      }
    }, 2000);

    return () => clearTimeout(timer);
  }
}, [mounted]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!agreePolicy) {
  setError("Please accept the Privacy Policy and Terms & Conditions.");
  setLoading(false);
  return;
}

if (!storeDataConsent) {
  setError(texts.dataConsentRequired);
  setLoading(false);
  return;
}
    setLoading(true);

    try {
      
      const response = await fetch("/app/api/check-user", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ contact }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.message === "Email or mobile not found") {
          // ✅ Log this specific invalid user attempt
          try {
            const res = await fetch("/app/api/login-error", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                user_input: contact,
                error_message: data.message || "Email or mobile not found",
                stack_trace: "N/A",
                browser_info: navigator.userAgent,
              }),
            });

            if (!res.ok) {
              console.warn("⚠️ Failed to log login error:", await res.text());
            } else {
              console.log("✅ Login error logged successfully");
            }
          } catch (logErr) {
            console.warn("⚠️ Failed to send login error log:", logErr);
          }

          setError("Invalid user or you don’t have a tag.");
        } else {
          setError(data.message || "An error occurred. Please try again.");
        }
      } else {
        router.push({
          pathname: "/authentication/verify-otp",
          query: { email: data.email, mobile: data.mobile, context: "prusr" },
        });
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    let current_qr = Cookies.get("current_qr");

    if (!current_qr) {
      // router.push("/")
      console.log("hello");
    } else {
      setCurrentQR(current_qr);
    }
  }, [currentQR]);

  // 🔹 PWA ALERT useEffect
useEffect(() => {
  if (!mounted) return;

  // ✅ ONLY LOGIN PAGE
  if (router.pathname !== "/authentication/login") return;

  if (window.deferredPrompt) {
    const timer = setTimeout(async () => {
      const allow = window.confirm(
        "📲 Add QRitagya to your Home Screen for faster access like an app!"
      );

      if (allow) {
        window.deferredPrompt.prompt();
        await window.deferredPrompt.userChoice;
        window.deferredPrompt = null;
      }
    }, 2000);

    return () => clearTimeout(timer);
  }
}, [mounted, router.pathname]);

  // 🔹 SSR guard (ISKO NAHI HATANA)
  if (!mounted) return null;


  return (
    <div
      className="position-relative d-flex flex-column justify-content-between overflow-x-hidden"
      style={{ minHeight: "100vh", backgroundColor: "#FFF" }}
    >
      <div>
        <img
          src="/app/assets1/img/inner-pic.jpg"
          alt="Inner Pic"
          style={{ width: "100%", height: "150px" }}
        />
      </div>

      {/* Form Section */}
      <div
        className="container d-flex justify-content-center"
        style={{ zIndex: 2, marginBottom: "120px" }}
      >
        <div style={{ width: "100%", maxWidth: "480px" }}>

          {brandInfo && (
            <div className="text-center mb-1 mt-2">
              {brandInfo?.brand?.brand_image && (
                <img
                  src={brandInfo.brand.brand_image}
                  alt="Brand"
                  style={{
                    maxWidth: "120px",
                    borderRadius: "10px",
                    marginBottom: "8px",
                  }}
                />
              )}

              {!!brandInfo?.brand?.welcome_message && (
                <p style={{ color: "#9d216d", fontWeight: 600, fontSize: "0.9rem" }}>
                  {brandInfo.brand.welcome_message}
                </p>
              )}

              {qrAlertMessage && (
                <p className="text-muted fw-semibold mb-0">{qrAlertMessage}</p>
              )}
            </div>

          )}

          {/* Heading */}
          <div className="mb-4 text-center ">
            <h5 className="fs-2 mt-3">{texts.loginHeading}</h5>
            <p className="text-muted fs-6">{texts.loginSubtext}</p>

          </div>
          {/* Social Login Buttons */}
          <div className="row g-3 mb-1">
            <div className="col-12 col-sm-6">
              <div className="d-grid">
                <GoogleLoginButton className="social-btn" onError={(err) => logLoginError({
                  user_input: "Google Login",
                  error_message: err?.message || "Google login failed",
                  stack_trace: err?.stack || "N/A",
                })} />
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="d-grid">
                <FacebookLoginButton className="social-btn" onError={(err) => logLoginError({
                  user_input: "Facebook Login",
                  error_message: err?.message || "Facebook login failed",
                })} />
              </div>
            </div>
            <div className="col-12 col-sm-6 offset-sm-3">
              <div className="d-grid">
                <AppleLoginButton className="social-btn" onError={(err) => logLoginError({
                  user_input: "Apple Login",
                  error_message: err?.message || "Apple login failed",
                })} />
              </div>
            </div>
          </div>
          <form
            onSubmit={handleLogin}
            style={{ maxWidth: "500px" }}
          >
            {/* Divider */}
            <div className="d-flex align-items-center my-4">
              <hr className="flex-grow-1 border-dark" />
              <span className="mx-2 text-muted">{texts.orText}</span>
              <hr className="flex-grow-1 border-dark" />
            </div>

            {/* Input */}
            <div className="mb-4 position-relative">
              <span
                className="position-absolute"
                style={{
                  top: "50%",
                  left: "18px",
                  transform: "translateY(-50%)",
                  color: "#666",
                  fontSize: "1.2rem",
                  zIndex: 2,
                }}
              >
                <FiMail />
              </span>
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder={texts.placeholderContact}
                value={contact}
                onChange={handleContactChange}
                required
                style={{
                  paddingLeft: "50px",
                  borderRadius: "0.75rem",
                }}
              />
            </div>

            {/* Error */}
            {error && <div className="text-danger mb-3 text-center">{error}</div>}
<div className="form-check mb-3">
  <input
    className="form-check-input"
    type="checkbox"
    id="agreePolicy"
    checked={agreePolicy}
    onChange={(e) => setAgreePolicy(e.target.checked)}
    required
  />

  <label
    className="form-check-label"
    htmlFor="agreePolicy"
    style={{ fontSize: "13px" }}
  >
    {texts.agreeText}{" "}

    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        setShowConsentModal(true);
      }}
      style={{
        color: "#A22191",
        textDecoration: "none",
        fontWeight: "500",
      }}
    >
      Consent Notice
    </a>{" "}

    {texts.and}{" "}

    <a
      href="https://www.qritagya.com/privacy-policy.php"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#A22191",
        textDecoration: "none",
        fontWeight: "500",
      }}
    >
      {texts.privacyPolicy}
    </a>{" "}

    {texts.and}{" "}

    <a
      href="https://www.qritagya.com/terms-conditions.php"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#A22191",
        textDecoration: "none",
        fontWeight: "500",
      }}
    >
      {texts.termsConditions}
    </a>.
  </label>
</div>
<div className="form-check mb-3">
  <input
    className="form-check-input"
    type="checkbox"
    id="storeDataConsent"
    checked={storeDataConsent}
    onChange={(e) => setStoreDataConsent(e.target.checked)}
    required
  />

  <label
    className="form-check-label"
    htmlFor="storeDataConsent"
    style={{
      fontSize: "13px",
      lineHeight: "1.4",
      fontWeight: 400,
    }}
  >
    {showConsent
      ? texts.dataConsentFull
      : texts.dataConsentShort}

<button
  type="button"
  className="btn btn-link p-0 ms-1"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowConsent(!showConsent);
  }}
  style={{
    fontSize: "13px",
    color: "#A22191",
    textDecoration: "none",
    verticalAlign: "baseline",
  }}
>
  {showConsent ? texts.seeLess : texts.seeMore}
</button>
  </label>
</div>
            {/* Submit Button */}
            <div className="d-grid mb-3">
              <button
                type="submit"
                className="btn btn-lg shadow"
                disabled={loading}
                style={{
                  backgroundColor: "#a22191",
                  color: "white",
                  border: "none",
                  borderRadius: "0.5rem",
                  padding: "0.75rem 1.25rem",
                }}
              >
                {loading ? texts.sendingOtp : texts.sendOtp}

              </button>
            </div>

            {currentQR && (
              <div className="d-flex justify-content-center mt-3">
                <Link
                  href="/authentication/sign-up"
                  className="text-decoration-none"
                  style={{ color: "gray", fontWeight: "500" }}
                >
                  {texts.newUser}{" "}
                  <span style={{ color: "#a22191", fontWeight: "600" }}>
                    {texts.createAccount}
                  </span>

                </Link>
              </div>
            )}
          </form>
        </div>
      </div>
   <Modal
  show={showConsentModal}
  onHide={() => setShowConsentModal(false)}
  centered
  size="lg"
  backdrop="static"
  keyboard={false}
>
  <div
    style={{
      borderRadius: "14px",
      overflow: "hidden",
      border: "2px solid #F4C542",
      boxShadow: "0 20px 50px rgba(0,0,0,0.3)",
      background: "#fff",
    }}
  >
    <Modal.Header
      closeButton
      style={{
        background: "linear-gradient(90deg,#FFF8E1,#FFF3CD)",
        borderBottom: "2px solid #F4C542",
        padding: "18px 24px",
      }}
    >
      <Modal.Title style={{ width: "100%" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <div
            style={{
              width: "55px",
              height: "55px",
              borderRadius: "50%",
              background: "#FFF3CD",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "30px",
              border: "2px solid #FFC107",
            }}
          >
            ⚠️
          </div>

          <div>
            <div
              style={{
                color: "#D97706",
                fontWeight: 700,
                fontSize: "12px",
                letterSpacing: "1px",
              }}
            >
              {texts.legalNotice}
            </div>

           <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <img
    src="/app/assets/new_qritagya_logo.png"
    alt="QRitagya Logo"
    style={{
      height: "45px",
      width: "auto",
    }}
  />

  <div
    style={{
      fontWeight: 700,
      fontSize: "24px",
      color: "#333",
    }}
  >
    {texts.companyName || "QRitagya LLP"}
  </div>
</div>

            <div
              style={{
                color: "#555",
                fontSize: "15px",
                marginTop: "2px",
              }}
            >
              {texts.noticeHeading}
            </div>
          </div>
        </div>
      </Modal.Title>
    </Modal.Header>

    <Modal.Body
      style={{
        padding: "25px",
        maxHeight: "60vh",
        overflowY: "auto",
        background: "#fff",
      }}
    >
      <div
        style={{
          background: "#FFF8E1",
          borderLeft: "6px solid #FFC107",
          padding: "15px 18px",
          borderRadius: "8px",
          marginBottom: "25px",
          color: "#6B4F00",
          lineHeight: "1.6",
          fontSize: "14px",
        }}
      >
        <strong>{texts.noticeReadTitle}</strong>
        <br />
        {texts.noticeReadDesc}
      </div>

      <ol
        style={{
          paddingLeft: "22px",
          margin: 0,
          color: "#444",
          fontSize: "15px",
          lineHeight: "1.9",
        }}
      >
        <li style={{ marginBottom: "18px" }}>
          <strong>{texts.personalDataTitle}</strong> {texts.personalDataDesc}
        </li>

        <li style={{ marginBottom: "18px" }}>
          <strong>{texts.purposeTitle}</strong>{" "}
          {texts.purposeDesc}
        </li>

        <li style={{ marginBottom: "18px" }}>
   <strong>{texts.consentTitle}</strong>{" "}
{texts.consentDesc}
        </li>

        <li style={{ marginBottom: "18px" }}>
      <strong>{texts.withdrawTitle}</strong>{" "}
{texts.withdrawDesc}{" "}
<a
  href="mailto:dpo@qritagya.com"
  style={{
    color: "#A22191",
    fontWeight: 600,
    textDecoration: "none",
  }}
>
  dpo@qritagya.com
</a>
          . {texts.withdrawExtra}
        </li>

        <li style={{ marginBottom: "18px" }}>
     <strong>{texts.rightsTitle}</strong>{" "}
{texts.rightsDesc}{" "}
<a
  href="mailto:dpo@qritagya.com"
  style={{
    color: "#A22191",
    fontWeight: 600,
    textDecoration: "none",
  }}
>
  dpo@qritagya.com
</a>
          .
        </li>

        <li style={{ marginBottom: "18px" }}>
      <strong>{texts.complaintTitle}</strong>{" "}
{texts.complaintDesc}{" "}
<a
  href="mailto:dpo@qritagya.com"
  style={{
    color: "#A22191",
    fontWeight: 600,
    textDecoration: "none",
  }}
>
  dpo@qritagya.com
</a>
          . {texts.complaintExtra}
        </li>

        <li>
          <strong>{texts.contactTitle}:</strong>

          <div
            style={{
              marginTop: "12px",
              background: "#F8F9FA",
              border: "1px solid #E5E5E5",
              borderRadius: "8px",
              padding: "15px",
            }}
          >
            QRitagya LLP
            <br />
            713, Devika Tower,
            <br />
            Nehru Place,
            <br />
            New Delhi – 110 019
            <br />
            <a
              href="mailto:dpo@qritagya.com"
              style={{
                color: "#A22191",
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              dpo@qritagya.com
            </a>
          </div>
        </li>
      </ol>
    </Modal.Body>

    <Modal.Footer
      style={{
        background: "#FAFAFA",
        borderTop: "1px solid #ECECEC",
        justifyContent: "space-between",
        padding: "15px 25px",
      }}
    >
      <span
        style={{
          color: "#666",
          fontSize: "13px",
          fontStyle: "italic",
        }}
      >
        {texts.footerNote}
      </span>

      <Button
        onClick={() => setShowConsentModal(false)}
        style={{
          background: "#A22191",
          border: "none",
          padding: "10px 30px",
          borderRadius: "8px",
          fontWeight: "600",
          fontSize: "15px",
          boxShadow: "0 4px 12px rgba(162,33,145,.3)",
        }}
      >
        {texts.understandBtn}
      </Button>
    </Modal.Footer>
  </div>
</Modal>
    </div>
    
  );
};

export default Login;
